document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.care-instruction');
    if (!container) return;

    const tabs = container.querySelectorAll('.care-instruction__tab');
    const contents = container.querySelectorAll('.care-instruction__content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const target = this.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        contents.forEach(content => {
          if (content.id === target) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      });
    });
  });